/* tslint:disable */
/* eslint-disable */
/**
 * data-center
 * data-center
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DataCenterNavigationCategory } from './DataCenterNavigationCategory';
import {
    DataCenterNavigationCategoryFromJSON,
    DataCenterNavigationCategoryFromJSONTyped,
    DataCenterNavigationCategoryToJSON,
    DataCenterNavigationCategoryToJSONTyped,
} from './DataCenterNavigationCategory';

/**
 * 
 * @export
 * @interface DataCenterNavigation
 */
export interface DataCenterNavigation {
    /**
     * 
     */
    home_dashboard_id: string | null;
    /**
     * 
     */
    categories: Array<DataCenterNavigationCategory>;
}

/**
 * Check if a given object implements the DataCenterNavigation interface.
 */
export function instanceOfDataCenterNavigation(value: object): value is DataCenterNavigation {
    if (!('home_dashboard_id' in value) || value['home_dashboard_id'] === undefined) return false;
    if (!('categories' in value) || value['categories'] === undefined) return false;
    return true;
}

export function DataCenterNavigationFromJSON(json: any): DataCenterNavigation {
    return DataCenterNavigationFromJSONTyped(json, false);
}

export function DataCenterNavigationFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataCenterNavigation {
    if (json == null) {
        return json;
    }
    return {
        
        'home_dashboard_id': json['home_dashboard_id'],
        'categories': ((json['categories'] as Array<any>).map(DataCenterNavigationCategoryFromJSON)),
    };
}

export function DataCenterNavigationToJSON(json: any): DataCenterNavigation {
    return DataCenterNavigationToJSONTyped(json, false);
}

export function DataCenterNavigationToJSONTyped(value?: DataCenterNavigation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'home_dashboard_id': value['home_dashboard_id'],
        'categories': ((value['categories'] as Array<any>).map(DataCenterNavigationCategoryToJSON)),
    };
}

